import { LinkField } from '@prismicio/client';
import { SliceClass } from './slice.class';

export class MenuItem extends SliceClass {
  title: string;
  link: LinkField;
}

export class SimpleMenuItem extends MenuItem {}
